<template>
    <div :class="$common.getClassName('conutry-componesnts')" v-if="packagelist.countrylength > 1">
        <div :class="$common.getClassName('conutry-box')" v-if="packagelistDone">
            <div :class="$common.getClassName('title')"  @click="onCountryUpandDown()" >
                <div :class="$common.getClassName('title-l')"><i>2</i><span v-html="$t('select_pay_country')"></span></div>
                <div :class="`${$common.getClassName('title-r')} ${$common.getClassName('conutry2-small')}`">
                    <span v-html="GET_SELECTED_COUNTRY_DATA['country_name']"></span>
                    <strong><img :src="GET_SELECTED_COUNTRY_DATA['logo_35_20']" :alt="GET_SELECTED_COUNTRY_DATA['country_name']"><i></i></strong>
                </div>
                <div :class="`${$common.getClassName('title-icon')} ${upandDown ? 'down': 'up'}`"></div>
            </div>

            <div :class="`${$common.getClassName('conutry2-cont')} ${upandDown ? 'show': 'hide'}`">
                <ul>
                    <li
                        :data-key="key" @click="onCountryUpandDown(key);CLICK_USER_SELECTED_COUNTRY({key:key,item:item});"
                        :class="key===packagelist.countrySelectedStatus ? 'active' : ''"
                        v-for="item,key in GET_COUNTRY_DATA"><img v-if="item['logo_140_70']"
                                                                  :src="item['logo_140_70']"
                                                                  :alt="item['country_name']"><i></i></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    export default {
        name: 'country2',
        components: {
        },
        data() {
            return {
                upandDown: false //false 收起，true 展开
            };
        },
        computed: {
            ...mapState(['$appConfig','$common']),
            ...mapState('Module_Package',['packagelist','packagelistDone']),
            ...mapGetters('Module_Package', ['GET_SELECTED_COUNTRY_DATA','GET_COUNTRY_DATA']),
        },

        created() {},

        watch: {
            packagelistDone(){
                this.upandDown = !this.packagelist.user_nopay_log ? false : true;
            }
        },

        methods:{

            onCountryUpandDown(key) {
                if (key === this.packagelist.countrySelectedStatus) return;
                this.upandDown = !this.upandDown;
            },

            ...mapActions('Module_Package', ['GET_PACKAGE_LIST_INFO','GET_USER_LAST_PAY_INFO','CLICK_USER_SELECTED_COUNTRY']),
        }


    };
</script>

<style type="scss">
</style>



// WEBPACK FOOTER //
// website/components/country/Country2.vue